
import { Component, ViewEncapsulation, AfterViewInit, ElementRef, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ForgotPasswordService } from '../forgot-password.service';
import { AuthResponseCode } from '../../constants/auth-response-code.enum';
import { RequestPasswordReset } from '../models/request-password-reset.model';
import { ConfirmPasswordValidator } from './confirm-password.validator';
import { PasswordComplexityValidator } from './password-complexity.validator';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResetPasswordComponent implements AfterViewInit {
  ngAfterViewInit() {
    document.getElementById('preloader').classList.add('hide');
  }

  @Input() public email: string;
  @Input() public resetToken: string;
  @Input() public isResendEnabled = true;

  @Output() public emailSent = new EventEmitter<RequestPasswordReset>();
  @Output() public updateSuccess = new EventEmitter();

  public form: FormGroup;
  @ViewChild("password") passwordRef: ElementRef;
  @ViewChild('confirmPassword') confirmPasswordRef: ElementRef;

  public password: AbstractControl;
  public confirmPassword: AbstractControl;

  public passwordUpdateSuccess = false;
  public errorMessage = '';
  public message = '';
  public isLoading = false;
  public isSending = false;
  public isPasswordResetComplete = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private forgotPasswordService: ForgotPasswordService
  ) {
    this.form = this.fb.group({
      'password': ['', Validators.compose([
        Validators.required,
        Validators.minLength(8),
        PasswordComplexityValidator.strong,
        PasswordComplexityValidator.hasLower,
        PasswordComplexityValidator.hasUpper,
        PasswordComplexityValidator.hasNumber,
      ])],
      'confirmPassword': ['', Validators.compose([Validators.required])]
    }, {
      validator: ConfirmPasswordValidator("password", "confirmPassword")
    });

    this.password = this.form.controls['password'];
    this.confirmPassword = this.form.controls['confirmPassword'];
  }

  async onSubmit() {
    const model = {
      email: this.email,
      password: this.password.value,
      confirmPassword: this.confirmPassword.value,
      resetToken: this.resetToken
    };

    await this.forgotPasswordService.submitPasswordReset(model);
    this.isPasswordResetComplete = true;
    this.message = "Password updated successfully. Redirecting back to login page...";
    setTimeout(() => this.router.navigate(['/auth/login']), 8000);

  }

  async resend() {
    if (this.isSending || !this.isResendEnabled) {
      return;
    }

    this.isSending = true;

    try {
      const model: RequestPasswordReset = {
        email: this.email,
      };

      const response = await this.forgotPasswordService.requestPasswordReset(model);

      switch(response) {
        case AuthResponseCode.PASSWORD_RESET_EMAIL_SENT:
          this.emailSent.emit(model);
          break;
        default:
          this.errorMessage = "An error occurred. Please try again.";
          break;
      }
    } catch(error) {
      this.errorMessage = "An error occurred. Please try again.";
    } finally {
      this.isSending = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/reset-password/reset-password.component.ts